import city from "./city.svg";
import continent from "./continent.svg";
import country from "./country.svg";
import districts from "./districts.svg";
import earth from "./earth.svg";
import houses from "./houses.svg";
import quarters from "./quarters.svg";
import regions from "./regions.svg";
import streets from "./streets.svg";

export const zoomTypesImages = {
  city,
  continent,
  country,
  districts,
  earth,
  houses,
  quarters,
  streets,
  regions,
};
